<section class="account-dialog">
  <header class="account-dialog__header">
    <div>
      <h2 id="account-change-username-title" class="account-dialog__title">
        {{ 'account.changeUsername.title' | translate }}
      </h2>
      <p id="account-change-username-description" class="account-dialog__description">{{ 'account.changeUsername.description' | translate }}</p>
    </div>

    <button
      type="button"
      class="account-dialog__close"
      [attr.aria-label]="'account.dialog.close' | translate"
      (click)="close()"
    >
      <span class="material-symbols-outlined account-dialog__close-icon" aria-hidden="true">close</span>
    </button>
  </header>

  @if (errorMessageKey(); as errorKey) {
    <p class="account-dialog__alert" role="alert">{{ errorKey | translate }}</p>
  }

  <form class="account-dialog__form" [formGroup]="form" [attr.aria-busy]="isSubmitting()" (ngSubmit)="submit()">
    @if (currentUser(); as user) {
      <div class="account-dialog__current">
        <span class="account-dialog__current-label">{{ 'account.changeUsername.currentUsername' | translate }}</span>
        <strong class="account-dialog__current-value">{{ user.Username }}</strong>
      </div>
    }

    <div class="account-dialog__field">
      <label class="account-dialog__label" for="account-new-username">
        {{ 'account.changeUsername.newUsername' | translate }}
      </label>
      <input
        id="account-new-username"
        class="account-dialog__input"
        [class.account-dialog__input--invalid]="form.controls.username.invalid && form.controls.username.touched"
        type="text"
        required
        formControlName="username"
        autocomplete="username"
        enterkeyhint="go"
        aria-describedby="account-new-username-hint"
        [attr.aria-invalid]="form.controls.username.invalid && form.controls.username.touched"
      />
      @if (form.controls.username.hasError('numbersOnly') && form.controls.username.touched) {
        <p id="account-new-username-hint" class="account-dialog__hint account-dialog__hint--error">
          {{ 'account.changeUsername.numbersOnly' | translate }}
        </p>
      } @else if (form.controls.username.invalid && form.controls.username.touched) {
        <p id="account-new-username-hint" class="account-dialog__hint account-dialog__hint--error">
          {{ 'account.changeUsername.constraints' | translate }}
        </p>
      } @else {
        <p id="account-new-username-hint" class="account-dialog__hint">
          {{ 'account.changeUsername.constraints' | translate }}
        </p>
      }
    </div>

    <div class="account-dialog__actions">
      <button type="button" class="account-dialog__secondary" (click)="close()">
        {{ 'account.dialog.cancel' | translate }}
      </button>
      <button type="submit" class="account-dialog__primary" [disabled]="form.invalid || isSubmitting()">
        {{ isSubmitting() ? ('account.dialog.saving' | translate) : ('account.changeUsername.submit' | translate) }}
      </button>
    </div>
  </form>
</section>
